import React from 'react';
import useSelectedPack from './useSelectedPack';

const ProductName = ({ showProductName = true, ...rest }) => {
  const { description = '' } = useSelectedPack();
  if (!showProductName) return <div className="h-10" {...rest}></div>;

  return (
    <div className="break-words h-10 w-full" {...rest}>
      <h3 className="block m-0 line-clamp-2 font-regular text-base leading-sm text-darkOnyx-800 pt-0.5 h-full">{description}</h3>
    </div>
  );
};

export default ProductName;
